<script>
import resources from './resources'

export default {
  name: 'covenant_form',
  mixins: [resources]
}
</script>

<template lang="pug">
  page(icon="", title="Meus Convênios")
    .col-xs-12.content
      .container-fluid
        .row
          .col-xs-12.white-bg
            .row
              .col-xs-12
                form.col-sm-10
                  .form-group.cadastro-form.col-md-12
                    .row
                      label(v-if="covenant.id") Beneficiário do Convênio Médico:
                       h4(style='margin-top: 10px; font-size: 18px;') {{ beneficiary }}
                      .form-group
                          f-select-patient(
                           id="dependent_id",
                            name="dependent_id",
                            v-if="!covenant.id",
                            v-model="covenant.dependent_id",
                            label="Beneficiário do Convênio Médico",
                            :get-all="true",
                            :searchable="false",
                            :errors="errors['dependent_id']",
                            @selected="onSelectedPatient")

                      .form-group.col-md-12(:class="{'has-error is-empty': $v.covenant.covenant_id.$error}")
                        .row
                          f-select-covenant(
                            id="covenants",
                            label="Convênio Médico",
                            name="covenants",
                            v-model="covenant.covenant_id",
                            :get-all="true",
                            :searchable="true",
                            :errors="errors['covenant_id']",
                            :disabled="!(!covenant.id)",
                            @selected="setPlansFromCovenant")
                          p.help-block(v-if='$v.covenant.covenant_id.$error')
                            strong(v-if='!$v.covenant.covenant_id.required')
                              | Campo obrigatório

                      .form-group.col-md-12
                        .row
                          f-select(v-if="covenant.covenant_id", label="Plano de Saúde (opcional)", name="plans", v-model="covenant.plan_id", :options="plans", :searchable="false", :errors="errors['plan_id']")
                      .form-group
                        .row
                          .col-xs-12.col-sm-6
                            f-text(label="Número Cartão", v-model="covenant.card_number", :errors="errors['card_number']")
                          .col-xs-12.col-sm-6
                            f-select-yes-no(label="Ativo", name="plans", v-model="covenant.active",  :searchable="false", :errors="errors['active']")
                      .form-group
                        .row
                          .buttons-wrapper
                            button.btn.cancel
                              router-link(:to="{ name: 'settings.covenants.index'}")
                                span.icon 
                                |  Cancelar

                            button.btn.save(@click.prevent="doSave()")
                              span.icon 
                              |  Salvar Alterações

</template>



// WEBPACK FOOTER //
// src/app/settings/covenants/form/form.vue